import { useParams } from "react-router-dom";
import BusinessDetailTabs from "./tabs";
import BusinessDetailProfile from "./profile";
import { useGetMemberByIdQuery } from "@/services/memberApi";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import useDocumentTitle from "@/components/ui/common/document-title";
import BusinessDetailSkeleton from "./skeleton/profile";
import BusinessDetailTabsSkeleton from "./skeleton/tabs";

export default function BusinessDetail() {
  const { memberId } = useParams();
  const orgId =
    useSelector((state: RootState) => state.auth.userInfo?.user?.org_id) || 0;

  const { data: memberInfo, isLoading: memberInfoLoading } =
    useGetMemberByIdQuery(
      { org_id: orgId, id: Number(memberId) },
      {
        skip: !memberId,
      }
    );

  useDocumentTitle("Member Details");

  if (memberInfoLoading) {
    return (
      <div className=" p-5 flex flex-col gap-3  justify-start items-start 2xl:flex-row ">
        <BusinessDetailSkeleton />
        <BusinessDetailTabsSkeleton />
      </div>
    );
  }

  return (
    memberInfo && (
      <div className=" p-5 flex flex-col gap-3  justify-start items-start 2xl:flex-row ">
        <BusinessDetailProfile memberInfo={memberInfo} />
        <BusinessDetailTabs memberInfo={memberInfo} />
      </div>
    )
  );
}
